export default "__VITE_ASSET__yB7OguDi__"